/**
 * Native boot splash: Capacitor SplashScreen + pre-JS window overlay (BootSplash).
 */
import { registerPlugin } from '@capacitor/core'
import { isNative } from './platform'

const BootSplash = registerPlugin('BootSplash')
const BRAND_NAVY = '#1E3A5F'

export function paintNativeBootBackground() {
  if (!isNative()) return
  try {
    document.documentElement.style.backgroundColor = BRAND_NAVY
    if (document.body) document.body.style.backgroundColor = BRAND_NAVY
  } catch { /* ignore */ }
}

export function hideNativeSplash() {
  if (!isNative()) return

  const attempt = async () => {
    try {
      const { SplashScreen } = await import('@capacitor/splash-screen')
      await SplashScreen.hide({ fadeOutDuration: 200 })
    } catch (e) {
      console.warn('[SplashScreen] hide failed:', e?.message || e)
    }
    try {
      await BootSplash.dismiss()
    } catch (e) {
      console.warn('[BootSplash] dismiss failed:', e?.message || e)
    }
  }

  attempt()
  setTimeout(attempt, 300)
}

if (typeof window !== 'undefined' && isNative()) {
  window.__hideNativeSplash = hideNativeSplash
}
